import { useState } from "react";
import { useNotify } from "ra-core";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { getSupabaseClient } from "../providers/supabase/supabase";

// Self-service password change for a logged-in user. Uses Supabase's native
// auth.updateUser — no `sales` table, no edge function (Atomic's ProfilePage
// relied on both, which the Idem spine doesn't have). Route: /change-password.

const ChangePasswordPage = () => {
  const notify = useNotify();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pw.length < 8) {
      notify("Password must be at least 8 characters", { type: "warning" });
      return;
    }
    if (pw !== confirm) {
      notify("Passwords do not match", { type: "warning" });
      return;
    }
    setSaving(true);
    const { error } = await getSupabaseClient().auth.updateUser({ password: pw });
    setSaving(false);
    if (error) {
      notify(`Could not change password: ${error.message}`, { type: "error" });
      return;
    }
    notify("Password changed", { type: "success" });
    setPw("");
    setConfirm("");
    navigate("/");
  };

  return (
    <div className="max-w-md mx-auto mt-8 p-4">
      <Card>
        <CardHeader>
          <CardTitle>Change password</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1">
              <Label htmlFor="pw">New password</Label>
              <Input id="pw" type="password" autoComplete="new-password"
                value={pw} onChange={(e) => setPw(e.target.value)} disabled={saving} />
            </div>
            <div className="space-y-1">
              <Label htmlFor="confirm">Confirm password</Label>
              <Input id="confirm" type="password" autoComplete="new-password"
                value={confirm} onChange={(e) => setConfirm(e.target.value)} disabled={saving} />
            </div>
            <div className="flex gap-2">
              <Button type="submit" disabled={saving}>{saving ? "Saving…" : "Change password"}</Button>
              <Button type="button" variant="outline" onClick={() => navigate("/")}>Cancel</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

ChangePasswordPage.path = "/change-password";
export default ChangePasswordPage;
